import { render, staticRenderFns } from "./NextOrdersGraph.vue?vue&type=template&id=28869cea&"
import script from "./NextOrdersGraph.vue?vue&type=script&lang=js&"
export * from "./NextOrdersGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports